var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"tag-age"},[_c('img',{attrs:{"src":_vm.imageFileName(),"alt":_vm.ageLimitsText}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }